import { cn } from '@ophelos/ui/lib/utils';
import * as ProgressPrimitive from '@radix-ui/react-progress';
import { cva, type VariantProps } from 'class-variance-authority';
import type * as React from 'react';

const progressIndicatorVariants = cva('h-full w-full flex-1 transition-all', {
  variants: {
    variant: {
      default: 'bg-primary',
      success: 'bg-green-500 dark:bg-green-400',
      warning: 'bg-amber-500 dark:bg-amber-400',
      destructive: 'bg-destructive',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

interface ProgressProps extends React.ComponentProps<typeof ProgressPrimitive.Root>, VariantProps<typeof progressIndicatorVariants> {
  /** Opacity applied to the indicator (0–1). */
  indicatorOpacity?: number;
}

function Progress({ className, value, variant, indicatorOpacity, ...props }: ProgressProps) {
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      className={cn('bg-muted-foreground/15 relative h-1.25 w-full overflow-hidden rounded-full', className)}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className={progressIndicatorVariants({ variant })}
        style={{ transform: `translateX(-${100 - (value || 0)}%)`, opacity: indicatorOpacity }}
      />
    </ProgressPrimitive.Root>
  );
}

export type { ProgressProps };
export { Progress, progressIndicatorVariants };
